import { LoggedInOfficer } from '../models/logged-in-officer.models';

export const OFFICER_BASE_DETAILS_KEY = 'officer-details';

export interface IOfficerBaseState {
  loggedInOfficer: LoggedInOfficer | null;
}

export const initialState: IOfficerBaseState = {
  loggedInOfficer: null,
};
